import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createBorrowerStateCheckThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(ApplyProcessActionTypes.BorrowerStateCheck, async (borrowerState: string) => {
    const response = await api.borrowerStateCheck(borrowerState);
    return response;
  });
